import { createSyncAction, IBaseAction } from '@bimser/core';
import * as ActionTypes from './actionTypes';
import { IModalState, ModalStateFactoryFromJS } from '../entities';

export default function openModalAction(data: IModalState): IBaseAction<any> {
	const action = createSyncAction(ActionTypes.OPEN_MODAL, ModalStateFactoryFromJS(data));

	return action;
}
